import type { LeadConversionTarget } from './sales-channel.js';

/** Party intent for a Lead funnel — not a DB column; derived from `source`. */
export const LEAD_INTENTS = ['client', 'partner'] as const;
export type LeadIntent = (typeof LEAD_INTENTS)[number];

/** Sources that mean partnership / supplier intake (not retail client). */
export const PARTNER_LEAD_SOURCES = ['partner-portfolio', 'landing-contact'] as const;

export type PartnerLeadSource = (typeof PARTNER_LEAD_SOURCES)[number];

export function isPartnerLeadSource(source: string | null | undefined): boolean {
  const s = source?.trim() ?? '';
  return (PARTNER_LEAD_SOURCES as readonly string[]).includes(s);
}

/** Derive prospect intent from capture `source` (flow slug or legacy magnet). */
export function leadIntentFromSource(source: string | null | undefined): LeadIntent {
  return isPartnerLeadSource(source) ? 'partner' : 'client';
}

export function leadIntentLabel(intent: LeadIntent): string {
  return intent === 'partner' ? 'Prospect partenaire' : 'Prospect client';
}

/** Short badge label for tables. */
export function leadIntentShortLabel(intent: LeadIntent): string {
  return intent === 'partner' ? 'Partenaire' : 'Client';
}

/** Suggested convert target when sales hit primary CTA. Override still allowed in detail. */
export function defaultLeadConversionTarget(source: string | null | undefined): LeadConversionTarget {
  return leadIntentFromSource(source) === 'partner' ? 'PARTNER' : 'CUSTOMER';
}

export function isLeadIntent(value: string): value is LeadIntent {
  return (LEAD_INTENTS as readonly string[]).includes(value);
}
